<template>
    <div class="mvt-collapse" :class="{active:active, disable: disable}">
        <button type="button" @click="toggle" class="mvt-collapse-link text-left" v-ga:clickable-multi :data-event-label="active?'open_panel':'close_panel'">
            <slot name="header" :collapsed="!active"></slot>
        </button>
        <div class="mvt-collapse-panel" v-show="active">
            <slot :collapsed="!active"></slot>
        </div>
    </div>
</template>
<script src="./mvt-collapse.js"></script>

<style lang="scss">
@use "./mvt-collapse.scss" as *;
</style>
